// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AppNavigation_wrapper__2UKR2","menuWrapper":"AppNavigation_menuWrapper__24pom","content":"AppNavigation_content__1ZjkI"};